import { render, staticRenderFns } from "./Meridian.vue?vue&type=template&id=2aa67ea1&"
import script from "./Meridian.vue?vue&type=script&lang=ts&"
export * from "./Meridian.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports